// React
import { useState } from 'react'

// Mobx
import { observer } from 'mobx-react'

// Components
import { BaseImage, SharedPhotoProfile } from 'components'

// Antd
import { Menu, Spin } from 'antd'
import { MenuUnfoldOutlined, CloseOutlined } from '@ant-design/icons'

// Interfaces
import { IBackOfficeSidebarProps } from './interfaces'
import { IRouteParent } from 'routes/route.interface'

// i18n
import { useTranslation } from 'react-i18next'

// React Router DOM
import { useHistory } from 'react-router-dom'

// Styles
import styles from './index.module.scss'
import './styles.scss'

// Custom Hook
import { useAuth, useBackOfficeRoutes } from 'hooks'

const BackOfficeSidebar = observer(({ meta, renderIcon }: IBackOfficeSidebarProps) => {
  // Hook
  const [toggleSidebar, setToggleSidebar] = useState<boolean>(false)
  const { t } = useTranslation()
  const history = useHistory()
  const { auth_authenticatedUser, auth_isVerifyLoading } = useAuth()
  const { parentRoutes } = useBackOfficeRoutes({ authenticatedUser: auth_authenticatedUser, module: meta.module })

  /**
   * @description Handle redirect
   *
   * @param {IRouteParent} route
   *
   * @return {void} void
   */
  const onRedirect = (route: IRouteParent) => {
    history.push(route.children?.[0]?.path)
  }

  return (
    <div className={`${styles['sidebar-container']} ${toggleSidebar ? styles['open'] : ''}`}>
      {/* Toggler - Mobile Only */}
      {!toggleSidebar ? (
        <MenuUnfoldOutlined
          className={styles['only-mobile']}
          style={{ fontSize: 24 }}
          onClick={() => setToggleSidebar(!toggleSidebar)}
        />
      ) : (
        <div className={styles['close-sidebar']}>
          <CloseOutlined
            className={styles['only-mobile']}
            style={{ fontSize: 24 }}
            onClick={() => setToggleSidebar(!toggleSidebar)}
          />
        </div>
      )}

      {/* Credentials */}
      <div className={styles['sidebar-credentials']}>
        <SharedPhotoProfile authenticatedUser={auth_authenticatedUser} isSidebar />
        <div className={'flex flex-col items-start ml-2'}>
          <p className={'font-16 font-weight-700'}>{auth_authenticatedUser.name}</p>
          <p className={'font-13 font-weight-400'}>{auth_authenticatedUser.email}</p>
        </div>
      </div>

      {/* Divider */}
      <div className={styles['sidebar-line']} />

      {/* Menu */}
      <Spin spinning={auth_isVerifyLoading || false}>
        <Menu
          defaultSelectedKeys={[meta.module]}
          mode="inline"
          theme="dark"
          inlineCollapsed={false}
          className={`layout-back-office-sidebar ${styles['sidebar']} basic mt-2`}
        >
          {parentRoutes.map(route => (
            <Menu.Item
              key={route?.meta?.attrs?.module}
              icon={<BaseImage isIcon isSvg icon={renderIcon(route?.meta?.attrs?.module!, route?.meta?.attrs?.icon!)} />}
              onClick={() => onRedirect(route)}
            >
              <div className="font-weight-400 ml-2">{t(route?.meta?.attrs?.label || '')}</div>
            </Menu.Item>
          ))}
        </Menu>
      </Spin>
    </div>
  )
})

export { BackOfficeSidebar }
